import Frame from "../common/Frame";
import React from "react";
import Footer from "../common/Footer";
import {useTranslation} from "react-i18next";
import {registerConcersion} from "../../logic/funel/FacebookUtils";

export function UsedLink() {
    const { t } = useTranslation();
    registerConcersion('UsedLink');
    return (
        <div>
            <Frame>
                <h2 className="offer-pay__title" id="usedLink">
                    {t("thisLinkWasAlreadyUsed")}
                </h2>
                <Footer/>
            </Frame>
        </div>
    );
}

